module.exports = "/assets/data/cf1997b632bcce507a924e1f00a3a43b-M12.data.json";